<app-select
	label="Acting for"
	[(ngModel)]="value"
	name="actingFor"
	class="mb-4 mt-4"
	[submitted]="submitted"
	[required]="required"
	[testHook]="testHooks.ActingForSelect"
>
	<option
		[value]="actingForTypes.MORTGAGEE"
		[testHook]="testHooks.MortgageeOption"
	>
		Mortgagee
	</option>
	<option
		[value]="actingForTypes.MORTGAGOR"
		[testHook]="testHooks.MortgagorOption"
	>
		Mortgagor
	</option>
	<option
		[value]="actingForTypes.BOTH_PRIMARY_MORTGAGEE"
		[testHook]="testHooks.Option2"
	>
		Both (primary client is Mortgagee)
	</option>
	<option
		[value]="actingForTypes.BOTH_PRIMARY_MORTGAGOR"
		[testHook]="testHooks.Option3"
	>
		Both (primary client is Mortgagor)
	</option>
</app-select>
